
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/environment",
      function () {
        return require("private-next-pages/solutions/environment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/environment"])
      });
    }
  